import React from 'react';
import { Box } from '@mui/material';
// import { createFilterOptions } from '@mui/material/Autocomplete';
import { useMutation } from 'react-query';
import axios, { endPoints } from 'api/request';
import throttle from 'lodash/throttle';
import { useRecoilState } from 'recoil';
import { OrderPayload } from 'pages/project-onboarding/store';
import Select, { CssTextField } from 'components/select';

// const filter = createFilterOptions();
const BusinessApplication = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [value, setValue] = React.useState(null);
    const [ccInputValue, setCCInputValue] = React.useState('-');
    const [options, setOptions] = React.useState([]);

    const bCiPostApi = useMutation((payload) => axios.post(`${endPoints.riServices.COMMON.businessCiDetails}`, payload));
    const setBusinessApplication = (businessApplication, businessApplicationDetails) => {
        setOrder({
            ...order,
            businessApplication,
            businessApplicationDetails,
            applicationService: order?.adoPlatform === 'Production' ? null : order?.applicationService,
            appOwner: null,
            appOwnerDetails: null,
        });
    };

    const resetOptions = () => {
        setOptions([]);
        setBusinessApplication(null, null);
    };

    const fetch = React.useMemo(
        () =>
            throttle((inputValue) => {
                bCiPostApi?.mutate({
                    businessApplication: inputValue,
                    applicationService: null,
                });
            }, 1000),
        []
    );

    const validateInput = () => {
        if (isTouched && order?.isTouched && !order?.businessApplication) {
            return 'validate';
        }
        return '';
    };

    React.useEffect(() => {
        if (ccInputValue === '') {
            resetOptions();
        }
        if (ccInputValue !== '' && ccInputValue.length > 2) fetch(ccInputValue);
    }, [ccInputValue, fetch]);

    React.useEffect(() => {
        if (bCiPostApi?.isSuccess) {
            if (bCiPostApi?.data?.data?.applications) {
                const combinedValue = bCiPostApi?.data?.data?.applications?.map((app) => ({
                    label: `${app.businessApplicationName}`,
                    value: app?.businessApplicationName,
                    data: app,
                }));
                setOptions(combinedValue);
            }
        }
    }, [bCiPostApi?.isSuccess]);

    const isExistsInOptions = (region) => {
        return options.find((option) => option?.label === region.label || option?.value === region);
    };

    React.useEffect(() => {
        if (value === null) {
            resetOptions();
        } else if (value) {
            setBusinessApplication(value?.label, value?.data);
        }
    }, [value]);

    React.useEffect(() => {
        if (options && options?.length === 1 && !order?.businessApplication) {
            setOrder({ ...order, businessApplication: options?.[0].label, businessApplicationDetails: options?.[0]?.data });
        }
        if (options && options?.length && order?.businessApplicationDetails && !order?.businessApplication) {
            const businessApplication = isExistsInOptions(order?.businessApplicationDetails);
            setOrder({ ...order, businessApplication: businessApplication?.label, businessApplicationDetails: businessApplication?.data });
        }
    }, [options]);

    React.useEffect(() => {
        if (!order?.businessApplication && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [order?.businessApplication, order?.isTouched]);
    const getNoOptionText = () => {
        let text = '';
        if (ccInputValue === '') {
            text = 'Type characters for suggestions.';
        } else if (options?.length === 0 && ccInputValue !== '') {
            text = 'No results found';
        }
        return text;
    };
    return (
        <>
            <Box display="flex" alignItems="center" gap={1}>
                <Select
                    key="businessApplication"
                    size="small"
                    loading={bCiPostApi?.isLoading}
                    label="Business Application *"
                    value={order?.businessApplication || null}
                    disabled={order?.adoPlatform !== 'Production' || order?.isToolsProject}
                    onInputChange={(event, newInputValue) => {
                        setCCInputValue(newInputValue);
                    }}
                    onChange={(event, newValue) => {
                        if (newValue && newValue.value !== 'no-results') {
                            setValue(newValue);
                        } else {
                            setValue(null);
                        }
                    }}
                    getOptionLabel={(option) => {
                        // Value selected with enter, right from the input
                        if (typeof option === 'string') {
                            return option;
                        }
                        // Add "xxx" option created dynamically
                        if (option.inputValue) {
                            return option.inputValue;
                        }
                        // Regular option
                        return option.label;
                    }}
                    filterOptions={(x) => x}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="free-solo-with-text-demo"
                    options={options}
                    renderInput={(params) => (
                        <CssTextField
                            // eslint-disable-next-line react/jsx-props-no-spreading
                            {...params}
                            label="Business Application *"
                            sx={{
                                '& label.MuiInputLabel-shrink': {
                                    color: '#0047BA !important',
                                },
                            }}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: <>{params.InputProps.endAdornment}</>,
                            }}
                            fullWidth
                        />
                    )}
                    className={validateInput()}
                    noOptionsText={getNoOptionText()}
                />
            </Box>
        </>
    );
};

export default React.memo(BusinessApplication);
